import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type EventScopedCoupleRoleQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type EventScopedCoupleRoleQuery = {
  __typename?: 'Query';
  me?: { __typename?: 'User'; id: string; scopedActiveEventUserForEvent?: { __typename?: 'EventUser'; id: string; status: Types.EventUserStatus } | null } | null;
};

export const EventScopedCoupleRoleDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EventScopedCoupleRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scopedActiveEventUserForEvent' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEventScopedCoupleRoleQuery__
 *
 * To run a query within a React component, call `useEventScopedCoupleRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventScopedCoupleRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventScopedCoupleRoleQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventScopedCoupleRoleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventScopedCoupleRoleQuery, EventScopedCoupleRoleQueryVariables>) {
  return ApolloReactHooks.useQuery<EventScopedCoupleRoleQuery, EventScopedCoupleRoleQueryVariables>(EventScopedCoupleRoleDocument, baseOptions);
}
export function useEventScopedCoupleRoleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventScopedCoupleRoleQuery, EventScopedCoupleRoleQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<EventScopedCoupleRoleQuery, EventScopedCoupleRoleQueryVariables>(EventScopedCoupleRoleDocument, baseOptions);
}
export type EventScopedCoupleRoleQueryHookResult = ReturnType<typeof useEventScopedCoupleRoleQuery>;
export type EventScopedCoupleRoleLazyQueryHookResult = ReturnType<typeof useEventScopedCoupleRoleLazyQuery>;
export type EventScopedCoupleRoleQueryResult = Apollo.QueryResult<EventScopedCoupleRoleQuery, EventScopedCoupleRoleQueryVariables>;
